var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55 17.0588V8.52941C11.55 6.65294 13.035 5.11765 14.85 5.11765H21.78C22.77 5.11765 23.43 4.43529 23.43 3.41176C23.43 2.38823 22.77 1.70588 21.78 1.70588H14.85C11.55 1.70588 8.745 4.26471 8.25 7.67647L4.455 6.14118C3.465 5.8 2.31 5.97059 1.485 6.48235C0.495 7.16471 0 8.18824 0 9.38235V17.9118C0 19.1059 0.495 20.1294 1.485 20.8118C1.98 21.1529 2.64 21.3235 3.3 21.3235C3.795 21.3235 4.125 21.3235 4.455 21.1529L10.395 18.5941C11.22 18.4235 11.55 17.7412 11.55 17.0588ZM8.25 15.8647L3.3 17.9118V9.38235L8.25 11.4294V15.8647ZM32.505 0.511765C31.845 -0.170588 30.855 -0.170588 30.195 0.511765L5.445 26.1C4.785 26.7824 4.785 27.8059 5.445 28.4882C5.775 28.8294 6.105 29 6.6 29C7.095 29 7.425 28.8294 7.755 28.4882L11.55 24.5647C12.54 25.2471 13.695 25.5882 14.85 25.5882H26.4C30.03 25.5882 33 22.5176 33 18.7647V8.52941C33 6.82353 32.34 5.28823 31.35 4.09412L32.505 2.9C33.165 2.21765 33.165 1.19412 32.505 0.511765ZM29.7 18.7647C29.7 20.6412 28.215 22.1765 26.4 22.1765H14.85C14.52 22.1765 14.355 22.1765 14.025 22.0059L29.04 6.48235C29.535 6.99412 29.7 7.84706 29.7 8.52941V18.7647Z",
    fill: "#134F98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleCam);
export default __webpack_public_path__ + "static/media/ToggleCam.cc42a8d965272d3b05984fbc89bb05f0.svg";
export { ForwardRef as ReactComponent };